<template>
    <div class="home">
        <!--<img src="" width="100%" height="100%" alt="" />-->
        <!-- 弹出框 -->
        <el-dialog :visible.sync="centerDialogVisible3" width="40%" center>
            <div class="dialog_tit" slot="title">学习说明</div>
            <div class="dialog_desc">
                1、在线课程学习总成绩占比{{ rates.studyRate }}%
                <br/>
                2、课程练习总成绩占比{{ rates.practiceRate }}%
                <br/>
                3、课程考试总成绩占比{{ rates.examRate }}%
                <br/>
                4、课程答疑笔记总成绩占比{{ rates.answerRate }}%
                <br/>
                <div>
                    根据每门课程的总学分不同，按照学习情况，实时转化成学分。
                    <br/>
                    每门课程总成绩达到{{ popup.rate }}及以上即为合格 eg：{{
                    popup.title
                    }}线上成绩总分{{ popup.total }}分，
                    <br/>
                    （在线课程学习+课程练习+课程考试+答疑笔记）≥{{
                    popup.rate
                    }}，合格。否则不合格
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
          <div @click="centerDialogVisible3 = false">确定</div>
        </span>
        </el-dialog>

        <div class="content_box">
            <!-- 公告 -->

            <!--<Msg :lists="lists"></Msg>-->
            <div class="headers-img">
                <div class="table-container" style="padding-top: 40px;margin-left: 15px; margin-right: 15px;">
                    <span style="font-size: 20px;margin-bottom: 10px">通知公告</span>
                    <el-table :data="noticeList.slice(0, 4)" size="mini" fit element-loading-text="Loading" border
                              highlight-current-row align="center" style="font-size: 18px;" @row-click="toMag">
                        <el-table-column label="序号" type="index" align="center" min-width="10%"></el-table-column>
                        <el-table-column label="通知" prop="title" align="center"></el-table-column>
                        <el-table-column label="发布时间" prop="addtime" :formatter="dateFormat" align="center"
                                         min-width="25%"></el-table-column>
                    </el-table>
                </div>

                <el-row :gutter="40" style="width: 100%; padding-top: 80px">
                    <el-col :xs="24" :sm="24" :lg="8">
                        <div class="msg_box1"
                             style="padding-top: 35px; border-radius: 30px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); width: 380px;height: 380px;background-color: #fff;">
                            <div class="plan_top1">
                                <div style="font-size: 20px;
                padding-left: 10px;">学院简介
                                    <a href="http://www.zzvcct.com/" target="_blank"
                                       style="margin-right:15px;float: right!important;color:#767676;">更多</a>
                                </div>
                                <div style="    line-height: 24px;
              font-size: 16px;
              color: #666;
              text-indent: 2em; margin-left: 15px; margin-right: 15px; margin-top: 30px" v-html="schoolInfo.frontIntro">
                                </div>


                            </div>

                        </div>
                    </el-col>

                    <el-col :xs="24" :sm="24" :lg="8">
                        <div style="padding-top: 35px;border-radius: 30px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width: 380px;height: 380px;background-color: #fff; ">
                            <PieChart :terms="terms" style="margin-top: 30px;" v-if="terms.length > 0"/>
                        </div>
                        <!--<div style="padding-top: 35px;border-radius: 30px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width: 380px;height: 380px;background-color: #fff; ">
                          <div class="nowTerm" style=" display: flex;
                          justify-content: space-between;
                          align-items: center;
                          margin-bottom: 20px; " >

                            <div class="learnState1" @click="centerDialogVisible = true">
                              &lt;!&ndash;<div>说明</div>&ndash;&gt;
                                <span style="padding-left: 10px;font-size: 15px; color:#778899" >当前学期：{{ Now.name }}（{{
                                (Now.beginTime * 1000) | dateFormat
                                }}-{{ (Now.endTime * 1000) | dateFormat }}）</span>

                                <img src="../assets/img/home/icon-5.png"  style="width: 15px; height: 15px"/>
                            </div>
                          </div>
                          <div id="myChart" :style="{ width: '350px', height: '330px' }"></div>
                        </div>-->


                    </el-col>
                    <el-col :xs="24" :sm="24" :lg="8">
                        <div style="padding-top: 35px;
        padding-right: 0px;
        padding-bottom: 30px;
        padding-left: 0px; border-radius: 30px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width: 380px;height: 350px; background-color: #fff;">
                            <div class="personal_tit" style="
          font-size: 20px;
          padding-left: 10px;
          ">
                                <span style="color:#778899"> 我的资料</span>
                            </div>
                            <div class="personal_body" style="padding-left: 10px;">
                                <!--style="broder-radius:2px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"-->
                                <div class="personal_body_top">
                                    <div class="per_bd_left">
                                        <div class="txImg">
                                            <!--<img src="../assets/img/home/img8.png" style="width: 105px; height: 105px;" />-->
                                            <div v-if="parseInt(userInfo.sex) == 1">
                                                <!--<div class="name" style="padding-top: 15px;font-size: 20px;">{{ userInfo.username }}</div>-->
                                                <img
                                                        class="gender"
                                                        src="../assets/img/home/girl.jpg"
                                                        style="width: 105px; height: 105px; float: left!important;"
                                                />
                                            </div>

                                            <div v-else>

                                                <img
                                                        class="gender"
                                                        src="../assets/img/home/boy.jpg"
                                                        style="width: 105px; height: 105px;float: left!important;"
                                                />
                                            </div>
                                        </div>
                                        <div class="name"
                                             style="padding-top: 20px; padding-left: 120px; font-size: 24px;color:#778899">
                                            {{ userInfo.username }}
                                        </div>
                                        <br/>
                                        <br/>
                                        <div style="padding-left: 120px;">
                                            <el-button type="success" @click="$router.push('/study')" round style="display: inline-block;
                    padding: 0 15px;
                    height: 25px;
                    line-height: 25px;
                    font-size: 16px;
                    color: #fff;
                    border-radius: 15px;">我的课程
                                            </el-button>
                                            <el-button type="warning" @click="$router.push('/test')" round style="display: inline-block;
                    padding: 0 15px;
                    height: 25px;
                    line-height: 25px;
                    font-size: 16px;
                    color: #fff;
                    border-radius: 15px;">考试练习
                                            </el-button>
                                        </div>
                                        <div class="info_box" style="padding-top: 57px;
                  padding-right: 0px;
                  padding-bottom: 0px;
                  padding-left: 10px;">
                                            <div style="font-size: 18px;">
                                                <span style="color:#778899	"> 账号： </span>

                                                <span style="font-size: 16px;color:#778899"> {{ userInfo.username }}</span>
                                            </div>
                                            <div style="font-size: 18px;">
                                                <span style="color:#778899	"> 层次： </span>
                                                <span style="font-size: 16px;color:#778899">{{ userInfo.levelName }}</span>

                                            </div>
                                            <div style="font-size: 18px;">
                                                <span style="color:#778899	"> 专业： </span>
                                                <span style="font-size: 16px;color:#778899">{{ userInfo.majorName }}</span>

                                            </div>
                                            <div style="font-size: 18px;">
                                                <span style="color:#778899	"> 年级：</span>
                                                <span style="font-size: 16px;color:#778899">
                      {{ userInfo.gradeName }}
                    </span>

                                                <div style="font-size: 18px;">
                                                    <span style="color:#778899	">  学号：</span>

                                                    <span style="font-size: 16px;color:#778899">
                      {{ userInfo.stuNum }}
                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="info_tips">
                                  毕业要求：各门课及格分值为65%，五个学期不挂科即为合格 准许毕业~
                                </div>-->
                            </div>
                        </div>

                    </el-col>

                </el-row>
            </div>

            <!-- 教学计划 -->
            <div class="plan">
                <div class="plan_top">
                    <div>教学计划</div>
                    <div
                            :class="{ active: more == 0 }"
                            @mouseenter="more = 0"
                            @mouseleave="more = -1"
                    >
                        <!-- 查看更多 -->
                    </div>
                </div>
                <div class="plan_body">
                    <!-- tabs切换 学期-->
                    <div class="plan_tabs">
                        <div
                                class="tabsitem"
                                v-for="(item, index) in semesterList"
                                :key="index"
                                :class="{ active2: active2 == index }"
                                @click="changeTabs(index)"
                        >
                            <div>
                                {{ item.name }}
                            </div>

                        </div>
                    </div>
                    <div>
                        学习时间：
                        {{ (this.start_time * 1000) | dateFormat }} ～ {{
                        (this.end_time * 1000) | dateFormat
                        }}
                        <img @click="centerDialogVisible3 = true" src="../assets/img/home/question.png"
                             style="margin-left:10px; margin-top: 5px; width: 25px; height: 25px"/>
                    </div>
                    <div class="plan_list" style="display: block;">
                        <div
                                class="list_box"
                                v-for="(item3, index3) in courses"
                                :key="index3"
                        >
                            <img class="listImg" src="../assets/img/home/sc.jpg" alt/>
                            <div class="list_right">
                                <div class="list_tit">

                                    <span class="t">{{ item3.name }}</span>
                                    <div class="b"></div>

                                    <p class="score">
                                      <span style="font-size: 14px;">已学视频：</span>{{ item3.learn}} /{{ item3.videos }}
                                    </p>

                                </div>
                                <div class="study">
                                    <div>
                                        <div v-if="item3.btn == 2" class="list_btn list_btn_n">
                                            已结束
                                        </div>
                                        <div v-if="item3.btn == 0" class="list_btn list_btn_n1">
                                            未开始
                                        </div>
                                        <div
                                                v-if="item3.is_pass == 1 && item3.btn == 1"
                                                class="list_btn"
                                        >
                                            已完成
                                        </div>
                                        <div
                                                v-if="item3.is_pass == 0 && item3.btn == 1"
                                                class="list_btn2"
                                                @click="toVideo(item3.id)"
                                                :class="{ current: current == index3 }"
                                                @mouseenter="current = index3"
                                                @mouseleave="current = -1"
                                        >
                                            开始学习
                                        </div>
                                    </div>

                                    <div>
                                        <div v-if="item3.btn == 2" class="list_btn list_btn_n">
                                            已结束
                                        </div>
                                        <div v-if="item3.btn == 0" class="list_btn list_btn_n1">
                                            未开始
                                        </div>
                                        <div
                                                v-if="item3.is_pass == 1 && item3.btn == 1"
                                                class="list_btn"
                                        >
                                            已完成
                                        </div>
                                        <div
                                                v-if="item3.is_pass == 0 && item3.btn == 1"
                                                class="list_btn2"
                                                @click="toPractice(item3.id)"
                                                :class="{ current2: current2 == index3 }"
                                                @mouseenter="current2 = index3"
                                                @mouseleave="current2 = -1"
                                        >
                                            课堂练习
                                        </div>
                                    </div>

                                    <div>
                                        <div v-if="item3.btn == 2" class="list_btn list_btn_n">
                                            已结束
                                        </div>
                                        <div v-if="item3.btn == 0" class="list_btn list_btn_n1">
                                            未开始
                                        </div>
                                        <div
                                                v-if="item3.is_pass == 1 && item3.btn == 1"
                                                class="list_btn"
                                        >
                                            已完成
                                        </div>
                                        <div
                                                v-if="item3.is_pass == 0 && item3.btn == 1"
                                                class="list_btn2"
                                                @click="toExam(item3.id)"
                                                :class="{ current3: current3 == index3 }"
                                                @mouseenter="current3 = index3"
                                                @mouseleave="current3 = -1"
                                        >
                                            在线考试
                                        </div>
                                    </div>


                                </div>

                                <div :class="[(item3.courseScore/item3.rates.examRate)> 60 ? 'grades':'grades1']">
                    <span>
                        总成绩
                    </span>
                                    <router-link class="score_link" to=""> {{item3.totalScore / item3.rates.examRate}}
                                    </router-link>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 遮罩层1-->

            <!-- 打开外层遮罩层 -->
            <el-dialog
                    custom-class="dialogOne"
                    :visible.sync="centerDialogVisible"
                    append-to-body
                    width="1200px"
                    center
            >
                <!-- 打开内层遮罩层 -->
                <el-dialog
                        width="567px"
                        style="border-radius: 15px"
                        :visible.sync="innerVisible"
                        top="40vh"
                        append-to-body
                >
                    <div class="con">确定开始练习试题吗</div>
                    <span slot="footer" class="dialog-footer interiorFooter">
            <div @click="close">取消</div>
            <div @click="goTxt" class="btn">确认</div>
          </span>
                </el-dialog>
                <!-- 遮罩层1的内容 -->
                <div class="dialogClose" @click="centerDialogVisible = false">
                    <i style="cursor: pointer" class="el-icon-error"></i>
                </div>
                <div class="diaTitle">课程练习</div>
                <div class="Exercise">
                    <div class="exerciseItem" v-for="(item, index) in exercise" :key="index">
                        <el-tooltip effect="dark" content="点击查看做题记录" placement="bottom-start">
                            <div class="itemIcon" @click="record($event,index,item.id)">
                                <img src="../assets/img/study/exam/icon_1_7.png"/>
                            </div>
                        </el-tooltip>
                        <div class="kong"></div>
                        <div class="exerciseTop">
                            <div class="exerciseNum">
                                <div class="exerciseLogo">
                                    <img src="../assets/img/study/exam/icon_1_6.png"/>
                                </div>
                                <div class="exerciseName">{{ item.examName }}</div>
                            </div>
                            <div class="explain">{{item.action}}</div>
                        </div>
                        <div class="exerciseBottom">
                            <div class="line"></div>
                            <div class="btmItem" v-if="!item.flag">
                                <div>卷面总分：{{ item.allScore }}</div>
                                <div>我的成绩：{{ item.maxScore }}</div>
                                <!--<div>学分：{{ item.score }}</div>-->
                                <div>剩余{{ item.remainingNum }}次机会</div>
                            </div>
                            <div class="btmItem1" v-else-if="item.flag&&item.recordList.length!=0">
                                <div
                                        class="recordItem"
                                        @click="analysis(item2.id)"
                                        v-for="(item2, index2) in item.recordList"
                                        :key="index2"
                                >
                                    <div>{{ item2.bookName }}</div>
                                    <div>{{ item2.examName }}</div>
                                </div>
                            </div>
                            <div class="without" v-else>暂无做题记录</div>
                        </div>
                        <div
                                class="diaBtn"
                                @click="openExam(item.id)"
                                :class="{ diaBtn1: item.status == 1 }"
                        >{{ item.status == 1 ? "已完成" : "开始练习" }}
                    </div>
                </div>
            </div>
                <div class="tip">Tip：本课程共有三套练习试卷，每套试卷共有20次机会，最终考试成绩取最高分</div>
            </el-dialog>
            <!-- 遮罩层2 -->
            <!-- 打开外层遮罩层 -->
            <el-dialog
                    width="1200px"
                    custom-class="dialogTwo"
                    :visible.sync="centerDialogVisible1"
                    append-to-body
            >
                <!-- 打开内层遮罩层 -->
                <el-dialog
                        width="356px"
                        custom-class="dialogTwo-inside"
                        :visible.sync="innerVisible1"
                        top="40vh"
                        append-to-body
                >
                    <div class="con">确认进入试题考试吗</div>
                    <span slot="footer" class="dialog-footer interiorFooter">
            <div @click="close1">取消</div>
            <div @click="goTxt" class="btn">确认</div>
          </span>
                </el-dialog>
                <!-- 遮罩层内容 -->
                <div class="bgc">
                    <div class="dialogClose dialogClose1" @click="centerDialogVisible1 = false,flag = true">
                        <i style="cursor: pointer;" class="el-icon-error"></i>
                    </div>
                    <div class="dialog2">
                        <!-- 内容左侧 -->
                        <div class="dialogLeft2">
                            <div class="leftTop2">
                                <div>课程考试</div>
                                <div>{{exercise1.examName}}</div>
                                <div>总分：{{exercise1.allScore }}分</div>
                            </div>
                            <div class="leftMid2" v-if="flag">{{exercise1.examName}}</div>
                            <div class="leftMid2" v-else>
                                <div class="leftMidList2" v-for="(item, index) in recordList" :key="index">
                                    <div class="leftMid2-left">
                                        <div class="leftMid2-leftImg">
                                            <img src="../assets/img/study/exam/icon_1_9.png"/>
                                        </div>
                                        <div>{{item.bookName}}</div>
                                        <div>{{item.examName}}</div>
                                    </div>
                                    <div @click="analysis(item.id)" class="leftMid2-right">查看详情</div>
                                </div>
                            </div>
                            <div class="leftBtn2">
                                <div @click="openExam1(exercise1.id)">开始考试</div>
                                <div @click="record1(exercise1.id)">考试记录</div>
                            </div>
                            <div class="leftBottom2">Tip：本次课程考试有{{exercise1.nums}}次机会，最终考试成绩取最高分</div>
                        </div>
                        <!-- 内容右侧 -->
                        <div class="dialogRight2">
                            <div class="dialogRight2-img">
                                <img src="../assets/img/study/exam/icon_1_9.png"/>
                            </div>
                            <div>卷面总分：{{exercise1.allScore}}</div>
                            <div>我的成绩：{{exercise1.maxScore}}</div>
                            <!--<div>学分：</div>-->
                            <div>剩余{{exercise1.nums}}次机会</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {getHome, uploadVideo, courseExercises,} from "../assets/js/api.js";
    import store from "store";
    import Msg from "@/components/msg.vue";
    import Bus from "../bus.js";
    import PieChart from "./PieChart"
    import moment from 'moment'

    export default {
        name: "Home",
        components: {
            Msg,
            PieChart,
        },
        data() {
            return {
                recordList: [],
                // 开始练习的遮罩层
                exercise: [],
                // 开始考试的遮罩层
                exercise1: [],
                courses: [],
                start_time: undefined,
                end_time: undefined,
                fileList: [],
                imgUrl: "./assets/img/home/bg-1.png",
                // 用户信息
                userInfo: "",
                // 学校信息
                schoolInfo: "",
                terms: [],
                // 教学计划
                semesterList: "",
                // 当前学期
                Now: "",
                nowIndex: 0,
                // 外层遮罩层
                centerDialogVisible: false,
                centerDialogVisible1: false,
                centerDialogVisible3: false,
                // 内层遮罩层
                innerVisible: false,
                innerVisible1: false,
                more: -1,
                active2: 0,
                current: -1,
                current2: -1,
                current3: -1,
                Etitle: "当前学期课程：",
                titNum: 2 / 5,
                lists: [], //轮播中的文字
                planList: [],
                // 公告列表
                noticeList: [],
                notice_img: "",
                // echarts数据
                across: [],
                information: [],
                titles: "",
                // 学习说明 弹框数据
                popup: {
                    title: "",
                    total: 0,
                    rate: 0,
                },
                rates: "",
                screenWidth: document.body.clientWidth
            };
        },
        created() {
            this.getHome();
        },
        mounted() {

            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.screenWidth = window.screenWidth
                })
            }

            window.scroll(0, 0);
        },

        watch: {
            screenWidth(val) {
                if (!this.timer) {
                    this.screenWidth = val
                    this.timer = true
                    let that = this
                    setTimeOut(function () {
                        that.timer = false
                    }, 400)
                }
            }
        },
        methods: {
            dateFormat(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date * 1000).format("YYYY-MM-DD HH:mm:ss");
            },

            //
            getHome() {
                getHome(localStorage.getItem("siteId"), localStorage.getItem("info")).then((res) => {
                    console.log(res, "获取信息")
                    if (res.code == 200) {
                        let i = 0
                        this.userInfo = res.data;
                        localStorage.setItem("users", JSON.stringify(res.data))
                        this.schoolInfo = res.data.site;
                        store.set("bannerImg", res.data.site.frontLogo);
                        this.semesterList = res.data.terms;
                        this.noticeList = res.data.notices;
                        if (!this.noticeList == undefined || !this.noticeList.length <= 0) {
                            this.lists = res.data.notices[0].title;
                        } else {
                            this.lists = "暂无公告！";
                        }
                        this.terms = res.data.terms;
                        console.log(this.terms, "学期")
                        if (this.noticeList.length > 6) {
                            this.noticeList.length = 6;

                        }
                        let semester = this.semesterList[0].myClasss[0].rates;
                        this.notice_img = res.data.notice_img;

                        // 学习说明
                        this.popup.title = this.semesterList[0].myClasss[0].name;
                        this.popup.total = this.semesterList[0].myClasss[0].score;
                        this.popup.rate = this.semesterList[0].myClasss[0].rate
                        this.rates = this.semesterList[0].myClasss[0].rates
                        console.log(this.semesterList);
                        // 学习
                        this.semesterList.forEach((item, index) => {
                            if (item.have_in_hand == 2) {
                                item.myClasss.forEach((item1) => {
                                    this.$set(item1, "btn", "2");
                                });
                            }
                            if (item.have_in_hand == 1) {
                                i = index
                                this.active2 = i
                                item.myClasss.forEach((item1) => {
                                    this.$set(item1, "btn", "1");
                                });
                            }
                            if (item.have_in_hand == 0) {
                                item.myClasss.forEach((item1) => {
                                    this.$set(item1, "btn", "0");
                                });
                            }
                        });

                        console.log(i, "index")
                        this.start_time = res.data.terms[i].beginTime;
                        this.end_time = res.data.terms[i].endTime;
                        this.courses = res.data.terms[i].myClasss;


                        Bus.$emit("schoolInfo", this.schoolInfo);
                        Bus.$emit("userInfo", this.userInfo);
                    }
                });
            },

            changeTabs(i) {
                this.active2 = i;
                this.nowIndex = i;
                this.start_time = this.semesterList[i].beginTime;
                this.end_time = this.semesterList[i].endTime;
                this.courses = this.semesterList[i].myClasss;

            },
            record(e, i, id) {
                this.exercise[i].flag = true;
                makeNotes(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
                    if (res.code == 200) {
                        this.exercise[i].recordList = res.data.record;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            record1(id) {
                this.flag = false;
                makeNotes(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
                    if (res.code == 200) {
                        this.recordList = res.data.record;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },

            //跳转到学习页面
            toVideo(id) {
                // 继续学习
                this.$router.push({
                    path: "/video",
                    query: {
                        id: id,
                    },
                });
            },
            // 跳转到课堂练习
            toPractice(id) {
                this.exercise = []
                this.centerDialogVisible = true;
                courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 3, id).then((res) => {
                    res.data.forEach((item) => {
                        item.flag = false;
                        item.recordList = [];
                    });
                    this.exercise = res.data;
                });
            },
            // 跳转到考试
            toExam(id) {
                this.centerDialogVisible1 = true;
                courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 1, id).then((res) => {
                    console.log(res, "试题")

                    this.exercise1 = res.data[0];
                });
            },
            // 跳转到补考
            toMakeUpExam() {
                courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 2, id).then((res) => {
                    res.data.forEach((item) => {
                        item.flag = false;
                        item.recordList = [];
                    });
                    this.exercise = res.data;
                });
            },
// 点击确定 进入试卷页面
            goTxt() {
                this.centerDialogVisible = false;
                this.innerVisible = false;
                this.centerDialogVisible1 = false;
                this.innerVisible1 = false;
                this.$router.push({path: "/exam", query: {c_e_id: this.c_e_id}});
            },
            openExam(id) {
                this.innerVisible = true;
                this.c_e_id = id;
            },
            openExam1(id) {
                this.innerVisible1 = true;
                this.c_e_id = id;

            },
            //跳转至错题解析
            analysis(id) {
                this.$router.push({path: "/analysis", query: {"examId": this.c_e_id, examDoId: id}});
            },
            // 练习 取消 关闭遮罩层
            close() {
                this.innerVisible = false;
            },
            // 考试 取消 关闭遮罩层
            close1() {
                this.innerVisible1 = false;
            },
            // 跳转到消息中心
            toMag(row) {
                this.$router.push({
                    path: "/msgDetail",
                    query: {
                        id: row.id,
                    },
                });
            },

        },
    };
</script>
<style lang="less" scoped>
    /*.home {
        background-image:url("../assets/img/home/img.png");
        width:100%;
        height: 100%;
    }*/
    /*.headers-img {
        background-image: url("../assets/img/home/img.png");
        background-position-x: center;
        background-position-y: top;
        background-size: 100%;
        background-repeat-x: no-repeat;
        background-repeat-y: repeat;
        background-attachment: initial;
        background-origin: initial;
        background-clip: initial;
        background-color: initial;

    }*/

    .plan_tabs::-webkit-scrollbar {
        width: 10px;
        height: 5px;
    }

    .plan_tabs::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
    }

    .plan_tabs::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
    }

    .plan_tabs::-webkit-scrollbar-thumb:hover {
        background: #bbb;
    }

    .plan_tabs::-webkit-scrollbar-corner {
        background: #179a16;
    }

    .home {
        margin-top: 60px !important;
    }

    .active {
        background-color: #f85415;
        color: #f8f3e8 !important;
    }

    .active2 {
        background-color: #ffa80a;
        color: #f8f3e8 !important;
    }

    .current {
        background-color: #f85415;
        color: #fff !important;
    }

    .current2 {
        background-color: #f85415;
        color: #fff !important;
    }

    .current3 {
        background-color: #f85415;
        color: #fff !important;
    }

    /deep/ .el-dialog__headerbtn {
        display: none;
    }

    /deep/ .el-dialog__header {
        padding: 0;
    }

    .dialog_tit {
        width: 100%;
        height: 74px;
        line-height: 74px;
        background-color: #f85415;
        font-size: 30px;
        color: #ffffff;
    }

    .dialog_desc {
        line-height: 2.5;
    }

    .dialog-footer {
        div {
            width: 180px;
            height: 50px;
            background: #ff551b;
            box-shadow: 3px 2px 0px 0px #ff9511;
            border-radius: 25px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            margin: 0 auto;
            cursor: pointer;
        }
    }

    .banner_box {
        width: 100%;
        height: 500px;
        // margin-top: 60px;
        .banner_img {
            width: 100%;
            height: 500px;
        }
    }

    .content_box {
        width: 1200px;
        margin: 0 auto;
        min-height: calc(100vh - 200px);
        .intro {
            position: relative;
            height: 465px;
            // display: flex;
            .intro_left {
                position: absolute;
                z-index: 1;
                top: 6%;
                left: 0px;
                width: 674px;
                height: 411px;
                background-color: #fff;
                padding: 25px 30px;
                box-sizing: border-box;
                .intro_name {
                    width: 220px;
                    height: 60px;
                    background: url("../assets/img/home/title-1.png") no-repeat;
                    background-size: 100%;
                    margin: 0 auto;
                    margin-bottom: 20px;
                }
                .intro_desc {
                    font-size: 14px;
                    color: #333;
                    line-height: 2;
                    p {
                        text-indent: 2em;
                    }
                }
            }
            .intro_right {
                position: absolute;
                right: 0;
                img {
                    width: 700px;
                    height: 465px;
                }
            }
        }
        .personal_info {
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
            .personal_left {
                width: 603px;
                height: 425px;
                background: url("../assets/img/home/bg-1.png") no-repeat;
                background-size: 100%;
                .personal_tit {
                    width: 100%;
                    height: 50px;
                    background: url("../assets/img/home/bg-2.png") no-repeat;
                    background-size: 100%;
                    font-size: 1000px;
                    color: #ff551b;
                    line-height: 50px;
                    padding-top: 18px;
                    padding-right: 0px;
                    padding-bottom: 30px;
                    padding-left: 0px;
                    box-sizing: border-box;
                }
                .personal_body {
                    padding: 0 40px;
                    box-sizing: border-box;
                    .personal_body_top {
                        margin: 50px 0;
                        .per_bd_left {
                            display: flex;
                            color: #fff;
                            font-size: 16px;
                            .txImg {
                                width: 106px;
                                height: 106px;
                                margin-right: 25px;
                                .name {
                                    font-size: 18px;
                                }
                                .gender {
                                    width: 16px;
                                    height: 16px;
                                    margin-left: 5px;
                                }
                                > div {
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    margin-left: 5px;
                                }
                            }
                            .info_box {
                                line-height: 2.5;
                            }
                        }
                    }
                    .info_tips {
                        font-size: 16px;
                        color: #fff;
                    }
                    .per_sign {
                        width: 523px;
                        height: 43px;
                        background: #ffffff;
                        border-radius: 21px;
                        font-size: 16px;
                        color: #ff551b;
                        text-align: left;
                        line-height: 43px;
                        padding: 0 25px;
                        box-sizing: border-box;
                        margin-top: 20px;
                    }
                }
            }
            .personal_right {
                width: 587px;
                height: 425px;
                // background-color: pink;
                padding: 15px;
                box-sizing: border-box;
                .nowTerm {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    .learnState {
                        cursor: pointer;
                    }
                    div:nth-child(1) {
                        font-size: 20px;
                        color: #333;
                    }
                    div:nth-child(2) {
                        font-size: 18px;
                        display: flex;
                        align-items: center;
                        div {
                            color: #ff551b !important;
                        }
                        img {
                            width: 18px;
                            height: 18px;
                            margin-left: 8px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .plan_top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 34px;
            margin: 50px 0;
            padding-left: 13px;
            box-sizing: border-box;
            div:nth-child(1) {
                font-size: 20px;
                color: #333;
            }
            div:nth-child(2) {
                font-size: 16px;
                color: #999;
                cursor: pointer;
            }
        }
        .plan {
            .plan_body {
                .plan_tabs {
                    display: flex;
                    // justify-content: space-between;
                    flex-wrap: wrap;
                    // overflow-x: scroll;
                    background-color: #ff551b;
                    overflow: auto;
                    .tabsitem {

                        div:nth-child(1) {
                            width: auto;
                            padding: 0 21px;
                            float: left;
                            height: 48px;
                            font-size: 16px;
                            color: #f8f3e8;
                            text-align: center;
                            line-height: 48px;
                            border-right-width: 1px;
                            border-right-style: solid;
                            border-right-color: orange;
                            -webkit-box-sizing: border-box;
                            -moz-box-sizing: border-box;
                            box-sizing: border-box;
                        }
                        div:nth-child(2) {
                            font-size: 14px;
                            color: #666666;
                            text-align: center;
                            margin-top: 5px;
                        }
                    }
                    .tabsitem:nth-child(5n) {
                        margin-right: 0;
                    }
                }
                .plan_list {
                    /*display: flex;*/
                    /*flex-wrap: wrap;*/
                    // justify-content: space-between;
                    margin-top: 18px;
                    border-top-color: rgb(221, 221, 221);
                    border-top-style: solid;
                    border-top-width: 1px;
                    border-right-color: rgb(221, 221, 221);
                    border-right-style: solid;
                    border-right-width: 1px;
                    border-bottom-color: rgb(221, 221, 221);
                    border-bottom-style: solid;
                    border-bottom-width: 1px;
                    border-left-color: rgb(221, 221, 221);
                    border-left-style: solid;
                    border-left-width: 1px;
                    border-image-source: initial;
                    border-image-slice: initial;
                    border-image-width: initial;
                    border-image-outset: initial;
                    border-image-repeat: initial;
                    .list_box {
                        border-bottom-width: 1px;
                        border-bottom-style: solid;
                        border-bottom-color: rgb(221, 221, 221);
                        list-style-position: initial;
                        list-style-image: initial;
                        list-style-type: none;
                        /*margin-bottom: 70px;*/
                        /*// margin-right: 95px;*/
                        /*margin-right: 45px;*/
                        .listImg {
                            // width: 235px;
                            width: 210px;
                            height: 122px;
                            float: left;
                            padding: 15px;
                        }
                        .list_right {
                            // width: 168px;
                            height: 155px;
                            border-bottom-width: 1px;
                            border-bottom-style: solid;
                            border-bottom-color: rgb(221, 221, 221);
                            list-style-position: initial;
                            list-style-image: initial;
                            list-style-type: none;
                            .list_tit {
                                font-size: 18px;
                                width: 500px;
                                height: 125px;
                                float: left;
                                padding: 15px;
                                border-right: 1px #ddd solid;
                                .t {
                                    font-size: 18px;
                                    font-family: "微软雅黑";
                                    color: #333;
                                    font-weight: 400;
                                    line-height: 20px;
                                    margin-bottom: 10px;
                                }
                                .b {
                                    height: 80px;
                                }
                            ;

                                .score {
                                    color: #ff551b;
                                    line-height: 16px;
                                    margin: 0px;
                                }
                            }
                            .study {
                                width: 200px;
                                height: 125px;
                                float: left;
                                padding-top: 20px;
                                padding-left: 90px;
                                padding-bottom: 15px;
                                border-right: 1px #ddd solid;
                                .list_btn {
                                    margin-top: 5px;
                                    width: 80px;
                                    height: 28px;
                                    border: 1px solid #ff551b;
                                    background: #02cb73;
                                    border-radius: 14px;
                                    text-align: center;
                                    line-height: 28px;
                                    color: #fff;
                                    font-size: 12px;
                                    cursor: pointer;

                                }
                                .list_btn2 {
                                    margin-top: 5px;
                                    width: 80px;
                                    height: 28px;
                                    border: 1px solid #ff551b;
                                    border-radius: 14px;
                                    text-align: center;
                                    line-height: 28px;
                                    color: #ff551b;
                                    font-size: 12px;
                                    cursor: pointer;
                                }
                                .list_btn_n {
                                    background: #999;
                                }
                                .list_btn_n1 {
                                    background: #cccccc;
                                }
                            }

                            .grades {
                                width: 85px;
                                padding-top: 10px;
                                padding-left: 30px;
                                float: left;
                                background: url("../assets/img/home/pass.png");
                                background-size: 80px;
                                background-repeat: no-repeat;
                                background-position: 30px;
                                background-position-y: 45px;

                                span {
                                    text-align: center;
                                    display: block;
                                    line-height: 50px;
                                    font-family: "微软雅黑";
                                    color: #ff551b;
                                }
                                .score_link {
                                    text-align: center;
                                    display: block;
                                    line-height: 50px;
                                    font-family: "微软雅黑";
                                    font-size: 30px;
                                    color: #525252;

                                }
                            }
                            .grades1 {
                                width: 85px;
                                padding-top: 10px;
                                padding-left: 30px;
                                float: left;
                                background: url("../assets/img/home/wpass.png");
                                background-size: 80px;
                                background-repeat: no-repeat;
                                background-position: 30px;
                                background-position-y: 45px;

                                span {
                                    text-align: center;
                                    display: block;
                                    line-height: 50px;
                                    font-family: "微软雅黑";
                                    color: #ff551b;
                                }
                                .score_link {
                                    text-align: center;
                                    display: block;
                                    line-height: 50px;
                                    font-family: "微软雅黑";
                                    font-size: 30px;
                                    color: #525252;

                                }
                            }

                        }
                    }
                    .list_box:nth-child(3n) {
                        margin-right: 0;
                    }
                }
            }
        }
        .msg_box {
            .msg_body {
                display: flex;
                margin-bottom: 60px;
                .msg_left {
                    width: 454px;
                    height: 284px;
                    // background-color: #0199ff;
                    margin-right: 35px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .msg_right {
                    width: 710px;
                    .rt_list {
                        display: flex;
                        // align-items: center;
                        justify-content: space-between;
                        font-size: 18px;
                        height: 50px;
                        color: #333;
                        > div:nth-child(1) {
                            display: flex;
                            cursor: pointer;
                        }
                        img {
                            width: 27px;
                            height: 23px;
                            margin-right: 10px;
                        }
                        .time {
                            color: #999;
                        }
                    }
                }
            }

        }
    }

    //遮罩层
    .dialogClose {
        position: relative;
        width: 100%;
        height: 30px;
        i {
            position: absolute;
            right: 20px;
            top: 0px;
            font-size: 30px;
            color: #4195f2;
        }
    }

    .diaTitle {
        text-align: center;
        color: #ff551b;
        font-size: 30px;
    }

    .Exercise {
        margin-top: 50px;
        margin-bottom: 50px;
        display: flex;
        justify-content: space-around;
    }

    .exerciseItem {
        position: relative;
        width: 303px;
        height: 344px;
        color: #fff;
        background: linear-gradient(90deg, #8555ff 0%, #b591ff 100%);
        box-shadow: 0px 7px 16px 0px rgba(88, 42, 197, 0.44);
        border-radius: 10px;
        &:nth-child(2) {
            background: linear-gradient(90deg, #6f70fe 0%, #9d9dff 100%);
            box-shadow: 0px 7px 16px 0px rgba(255, 117, 29, 0.3);
        }
        &:nth-child(3) {
            background: linear-gradient(90deg, #ff973c 0%, #68cbff 100%);
            box-shadow: 0px 7px 16px 0px rgba(255, 85, 27, 0.44);
        }
    }

    .itemIcon {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 25px;
        height: 22px;
        cursor: pointer;
    }

    .kong {
        height: 20px;
    }

    .exerciseTop {
        height: 100px;
        text-align: center;
        .exerciseNum {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            font-weight: bold;
        }
        .exerciseLogo {
            width: 46px;
            height: 47px;
            margin-right: 20px;
        }
        .explain {
            margin-top: 15px;
            margin-bottom: 15px;
        }
    }

    .exerciseBottom {
        margin-left: 25px;
        margin-right: 25px;
        .line {
            height: 1px;
            opacity: 0.3;
            background-color: #ffffff;
        }
        // 练习封面
        .btmItem {
            display: flex;
            flex-wrap: wrap;
            div {
                margin-top: 15px;
                width: 50%;
            }
        }
        // 做题记录
        .btmItem1 {
            margin-top: 10px;
            height: 140px;
            overflow-x: hidden; /* 解决左右可以滑动的问题 */
            overflow-y: auto;
            .recordItem {
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                div {
                    margin-right: 10px;
                }
            }
        }
        // 暂无做题记录
        .without {
            text-align: center;
            padding-top: 40px;
        }
    }

    // 修改滚动条样式
    div::-webkit-scrollbar {
        width: 4px;
        height: 5px;
    }

    div::-webkit-scrollbar-track {
        background: rgba(191, 191, 191, 0.2);
        border-radius: 4px;
    }

    div::-webkit-scrollbar-thumb {
        background: #fff;
        border-radius: 4px;
    }

    .one::-webkit-scrollbar {
        width: 4px;
        height: 5px;
    }

    .one::-webkit-scrollbar-track {
        background: rgba(191, 191, 191, 0.4);
        border-radius: 4px;
    }

    .one::-webkit-scrollbar-thumb {
        background: rgba(191, 191, 191, 0.6);
        border-radius: 4px;
    }

    .diaBtn {
        position: absolute;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);
        display: inline-block;
        width: 112px;
        height: 38px;
        line-height: 38px;
        background-color: rgba(255, 255, 255, 0.4);
        color: #fff;
        border-radius: 19px;
        text-align: center;
        cursor: pointer;
    }

    .diaBtn1 {
        background-color: #fff;
        color: #ff6e39;
    }

    .tip {
        font-size: 14px;
        text-align: center;
        color: #ff6e39;
    }

    // 内部遮罩层
    /deep/ .el-dialog__footer {
        padding: 0;
    }

    /deep/ .dialogOne {
        border-radius: 15px;
        overflow: hidden;
    }

    .con {
        margin: 30px 0;
        color: #333;
        font-size: 22px;
        font-weight: 500;
    }

    .interiorFooter {
        display: flex;
        height: 80px;
        line-height: 30px;
        cursor: pointer;
        div {
            width: 80px;
            font-size: 18px;
            text-align: center;
            color: #ff6e39;
        }
        .btn {
            background-color: #f8f3e8;
            color: #ff6e39;
        }
    }

    /deep/ .dialogTwo {
        border-radius: 16px;
    }

    /deep/ .dialogTwo .el-dialog__body {
        padding: 0;
    }

    /deep/ .dialogTwo-inside {
        border-radius: 16px;
        overflow: hidden;
    }

    /deep/ .dialogTwo-inside .el-dialog__body {
        padding: 0 20px;
    }

    .bgc {
        height: 580px;
        background-image: url("../assets/img/study/exam/bg_1_9.png");
        background-repeat: no-repeat;
    }

    // 遮罩层2
    .dialogClose1 {
        height: 45px;
        margin-bottom: 10px;
        i {
            margin-top: 15px;
            color: #fff;
        }
    }

    .dialog2 {
        color: #ff6e39;
        width: 980px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 170px;
        margin-right: 50px;
        height: 500px;
    }

    .dialogLeft2 {
        width: 584px;

        font-size: 18px;
        .leftTop2 {
            text-align: center;
            div {
                margin-top: 8px;
                &:first-child {
                    font-size: 30px;
                }
            }
        }
        .leftMid2 {
            margin-top: 10px;
            padding: 30px;
            height: 215px;
            overflow: auto;
            border-radius: 10px;
            font-size: 16px;
            background: rgba(255, 255, 255, 0.1);
            line-height: 30px;
        }
        .leftBtn2 {
            margin: 20px 0;
            display: flex;
            justify-content: space-around;
            div {
                width: 160px;
                height: 50px;
                line-height: 50px;
                background: #ffffff;
                border-radius: 10px;
                color: #ff6e39;
                text-align: center;
                cursor: pointer;
                &:last-child {
                    color: #fff;
                    border: 1px solid #fff;
                    background: transparent;
                }
            }
        }
        .leftBottom2 {
            text-align: center;
            font-size: 14px;
        }
    }

    .dialogRight2 {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 268px;
        height: 324px;
        padding: 30px;
        font-size: 16px;

        background: rgba(255, 255, 255, 0.1);
        .dialogRight2-img {
            width: 50px;
            height: 50px;
        }
    }

</style>
